module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_iterators.js
// module id = 21
// module chunks = 0